/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_2_Item_2_TitleInputs */

const en_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA of America member since 1983`)
};

const es_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembro de la PGA of America desde 1983`)
};

const de_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied der PGA of America seit 1983`)
};

const zh_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自 1983 年起成为 PGA of America 会员`)
};

const ar_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عضو في PGA of America منذ 1983`)
};

const fr_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membre de la PGA of America depuis 1983`)
};

const vi_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành viên PGA of America từ năm 1983`)
};

const sw_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwanachama wa PGA of America tangu 1983`)
};

const th_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมาชิก PGA of America ตั้งแต่ปี 1983`)
};

const bs_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Član PGA of America od 1983.`)
};

const ja_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1983年からPGA of America会員`)
};

const ko_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1983년부터 PGA of America 회원`)
};

const pt_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro da PGA of America desde 1983`)
};

const it_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro della PGA of America dal 1983`)
};

const sv_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medlem i PGA of America sedan 1983`)
};

const nl_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lid van de PGA of America sinds 1983`)
};

const da_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medlem af PGA of America siden 1983`)
};

const nb_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medlem av PGA of America siden 1983`)
};

const fi_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA of America -jäsen vuodesta 1983`)
};

const pl_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Członek PGA of America od 1983 r.`)
};

const ru_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Член PGA of America с 1983 года`)
};

const tr_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1983'ten beri PGA of America üyesi`)
};

const hi_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1983 से PGA of America के सदस्य`)
};

const id_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota PGA of America sejak 1983`)
};

const ms_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahli PGA of America sejak 1983`)
};

const cs_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Člen PGA of America od roku 1983`)
};

const el_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μέλος της PGA of America από το 1983`)
};

const he_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חבר PGA of America מאז 1983`)
};

const af_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA of America-lid sedert 1983`)
};

const hu_about_content_honor_2_item_2_title = /** @type {(inputs: About_Content_Honor_2_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A PGA of America tagja 1983 óta`)
};

/**
* | output |
* | --- |
* | "PGA of America member since 1983" |
*
* @param {About_Content_Honor_2_Item_2_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_2_item_2_title = /** @type {((inputs?: About_Content_Honor_2_Item_2_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_2_Item_2_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_2_item_2_title(inputs)
	if (locale === "de") return de_about_content_honor_2_item_2_title(inputs)
	if (locale === "zh") return zh_about_content_honor_2_item_2_title(inputs)
	if (locale === "ar") return ar_about_content_honor_2_item_2_title(inputs)
	if (locale === "fr") return fr_about_content_honor_2_item_2_title(inputs)
	if (locale === "vi") return vi_about_content_honor_2_item_2_title(inputs)
	if (locale === "sw") return sw_about_content_honor_2_item_2_title(inputs)
	if (locale === "th") return th_about_content_honor_2_item_2_title(inputs)
	if (locale === "bs") return bs_about_content_honor_2_item_2_title(inputs)
	if (locale === "ja") return ja_about_content_honor_2_item_2_title(inputs)
	if (locale === "ko") return ko_about_content_honor_2_item_2_title(inputs)
	if (locale === "pt") return pt_about_content_honor_2_item_2_title(inputs)
	if (locale === "it") return it_about_content_honor_2_item_2_title(inputs)
	if (locale === "sv") return sv_about_content_honor_2_item_2_title(inputs)
	if (locale === "nl") return nl_about_content_honor_2_item_2_title(inputs)
	if (locale === "da") return da_about_content_honor_2_item_2_title(inputs)
	if (locale === "nb") return nb_about_content_honor_2_item_2_title(inputs)
	if (locale === "fi") return fi_about_content_honor_2_item_2_title(inputs)
	if (locale === "pl") return pl_about_content_honor_2_item_2_title(inputs)
	if (locale === "ru") return ru_about_content_honor_2_item_2_title(inputs)
	if (locale === "tr") return tr_about_content_honor_2_item_2_title(inputs)
	if (locale === "hi") return hi_about_content_honor_2_item_2_title(inputs)
	if (locale === "id") return id_about_content_honor_2_item_2_title(inputs)
	if (locale === "ms") return ms_about_content_honor_2_item_2_title(inputs)
	if (locale === "cs") return cs_about_content_honor_2_item_2_title(inputs)
	if (locale === "el") return el_about_content_honor_2_item_2_title(inputs)
	if (locale === "he") return he_about_content_honor_2_item_2_title(inputs)
	if (locale === "af") return af_about_content_honor_2_item_2_title(inputs)
	if (locale === "hu") return hu_about_content_honor_2_item_2_title(inputs)
	return en_about_content_honor_2_item_2_title(inputs)
});